/** @jsx jsx */
import { css, jsx } from '@emotion/core';

const whatCss = css`
  padding: 5em 20px;
  text-align: center;
  background-color: #fff;
`;

const wrapperCss = css`
  max-width: 700px;
  margin: 0 auto;
  font-size: 1.2em;
  line-height: 2em;
  white-space: pre-line;
  > p {
    margin: 3em 0;
  }
`;

const What = ({ text }) => (
  <section css={whatCss} name="what">
    <div css={wrapperCss} dangerouslySetInnerHTML={{ __html: text }} />
  </section>
);

export default What;
